import { defaultPerson, IPerson } from "features/production/models/Person"


export interface IDoctor {

    id: number,
    
    personId: number,
    licenseNumber: string,
    
    specialityCode: string,
    
    person: IPerson,

    firstName: string,
    lastName: string,

    fullName: string,
    fullNameFR: string,
    fullNameEN: string,
        
    portable1: string,
    portable2: string,
    email1: string,
    email2: string,
  }


  
  export const defaultDoctor : IDoctor = {
    id: 0,
    
    personId: 0,
    licenseNumber: '',
    
    specialityCode: '',
    
    person: defaultPerson,

    firstName: '',
    lastName: '',

    fullName: '',
    fullNameFR: '',
    fullNameEN: '',
        
    portable1: '',
    portable2: '',
    email1: '',
    email2: ''    
  }

  export interface IDoctorSearch {
    
    firstName: string,
    lastName: string,       

    portable: string,
    email: string 
  }

  